import React from "react";
import LegalLayout from "components/LegalLayout";
import { LEGAL } from "components/LegalLayout/legalMeta";

// Privacy Policy — PRIVACY ONLY. The Terms of Service live on a
// separate page (/terms); TikTok Login-Kit review requires the two to
// be distinct pages. Keep data-handling content here; keep service /
// billing / acceptable-use terms on the Terms page.

const Privacy = () => (
  <LegalLayout title={LEGAL.privacy.title} other={LEGAL.privacy.other}>
    <p>
      This Privacy Policy explains how Prigmar (“Prigmar”, “we”, “us”) collects,
      uses, and protects information when you use the Prigmar AI business
      management platform at app.prigmar.com (the “Service”). By using the
      Service you agree to this Policy.
    </p>

    <h2>1. Information We Collect</h2>
    <ul>
      <li><strong>Account information</strong> — name, email address, and password you provide when registering.</li>
      <li><strong>Content you create</strong> — brands, posts, campaigns, and other material you generate or upload in the Service.</li>
      <li><strong>Connected accounts</strong> — when you connect a third-party account (such as TikTok, Facebook, Instagram, LinkedIn, or X), we receive access tokens and the profile and content data you authorize through that platform’s OAuth consent screen.</li>
      <li><strong>Usage data</strong> — log data, device/browser information, and actions taken in the Service, used to operate and improve it.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>
      We use your information to provide and operate the Service, to publish and
      schedule content to the accounts you connect at your direction, to
      authenticate you, to provide support, and to maintain the security and
      reliability of the platform.
    </p>

    <h2>3. Social Media Platform Data</h2>
    <p>
      When you connect a social account, we access that platform’s data only
      with your authorization and only to perform the actions you request — for
      example reading your basic profile and publishing content you create. Our
      access to and use of information received from these platforms (including
      TikTok) complies with the relevant platform’s developer terms and
      policies. We do not use this data for advertising profiling and we do not
      sell it. You can revoke access at any time by disconnecting the account in
      the Service or in the platform’s own settings.
    </p>

    <h2>4. Cookies</h2>
    <p>
      We use necessary cookies for sign-in and core functionality and optional
      cookies to understand usage. You can manage cookies through your browser
      settings.
    </p>

    <h2>5. How We Share Information</h2>
    <p>
      We do not sell your personal data. We share data only with the social
      platforms you choose to connect (to perform the actions you request) and
      where required by law. We do not share your data with third-party
      marketers.
    </p>

    <h2>6. Data Retention</h2>
    <p>
      We retain account data while your account is active. Usage logs are kept
      for a limited period for security and reliability. You may request earlier
      deletion at any time (see Section 9).
    </p>

    <h2>7. Data Security</h2>
    <p>
      We protect your data with SSL encryption in transit, encryption of stored
      access tokens, restricted staff access, and monitoring. No method of
      transmission or storage is completely secure, but we work to protect your
      information and will notify you of a breach where required.
    </p>

    <h2>8. International Transfers</h2>
    <p>
      Data is stored in U.S. data centers. Where data is transferred
      internationally, we apply appropriate safeguards consistent with
      applicable law.
    </p>

    <h2>9. Your Rights &amp; Data Deletion</h2>
    <p>
      You may request access to, correction of, or deletion of your personal
      data. To delete your data, email{" "}
      <a href="mailto:support@prigmar.com">support@prigmar.com</a> from your
      account address; we confirm requests within 24 hours and complete deletion
      promptly. Disconnecting a social account removes our stored access tokens
      for that platform.
    </p>

    <h2>10. Children’s Privacy</h2>
    <p>The Service is intended for businesses and users aged 18 and over. We do not knowingly collect data from children.</p>

    <h2>11. Changes to This Policy</h2>
    <p>We may update this Policy and will revise the “Last updated” date above. Material changes will be communicated through the Service.</p>

    <h2>12. Contact</h2>
    <p>
      Prigmar<br />
      <a href="mailto:support@prigmar.com">support@prigmar.com</a><br />
      +1 928 478 1277<br />
      64 E Broadway Rd, Suite 200, Tempe, AZ, USA
    </p>
  </LegalLayout>
);

export default Privacy;
